<div class="container container-skills">
    <h1 id="skills-title">My skills</h1>

    <main id="main-skills">

        <mat-card>
            <mat-card-title>Java</mat-card-title>
            <mat-progress-spinner value="80"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>HTML</mat-card-title>
            <mat-progress-spinner value="100"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>CSS</mat-card-title>
            <mat-progress-spinner value="95"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>Spring</mat-card-title>
            <mat-progress-spinner value="80"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>Angular</mat-card-title>
            <mat-progress-spinner value="90"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>Python</mat-card-title>
            <mat-progress-spinner value="50"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>Bootstrap</mat-card-title>
            <mat-progress-spinner value="95"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>JavaScript</mat-card-title>
            <mat-progress-spinner value="95"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>TypeScript</mat-card-title>
            <mat-progress-spinner value="90"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>Docker</mat-card-title>
            <mat-progress-spinner value="20"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>SCRUM</mat-card-title>
            <mat-progress-spinner value="20"></mat-progress-spinner>
        </mat-card>

        <mat-card>
            <mat-card-title>Angular Material</mat-card-title>
            <mat-progress-spinner value="50"></mat-progress-spinner>
        </mat-card>

    </main>
</div>